
import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core'
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from '../../../../shared/services/auth.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { LocalStorageService } from '../../../../shared/services/local-storage.service';
import { watsappURL } from '../../../../../env-config';

import $ from 'jquery';

@Component({
  selector: 'app-manax-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
})
export class SidebarComponent implements OnInit, AfterViewInit {
  @ViewChild('snav') snav!: MatSidenav;
  menuCollapsed: boolean = false;
  profile: any = null;
  companyName!: string;
  companies: any = [];
  isManax: boolean = false;
  constructor(
    private _AuthService: AuthService,
    private _broadcaster: Broadcaster,
    private ref: ChangeDetectorRef,
    private _LocalStorageService: LocalStorageService
  ) { }

  ngOnInit() {
    this.profile = this._AuthService.profile();
    this.companies = this.profile.company;
    this.companyName = this.companies[this._AuthService.companyIndex()].name;
    this.isManax = this._AuthService.isManax();
  }

  ngAfterViewInit() {
    const state: any = this._LocalStorageService.getItem('lavuro-menu-state');
    this.menuCollapsed = !state.collapsed;
    // if (!state.open) this.snav.close();
    this._broadcaster.broadcast('OnResizeMenu', true);
  }

  isMobileMenu(): boolean {
    if (typeof window !== 'undefined' && window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  isMode() {
    return this.isMobileMenu() ? 'over' : 'side';
  }

  sidenavChange(type?: string) {

    if (!this.snav.opened || type == 'open') {
      this.menuCollapsed = false;
      this.snav.open();
      this._broadcaster.broadcast('OnResizeMenu', true);
      const state: any = { open: true, collapsed: false };
      this._LocalStorageService.setItem('lavuro-menu-state', state);
      return;
    }

    else if (!this.isMobileMenu() && (!this.menuCollapsed || type == 'collapsed')) {
      // this.menuCollapsed = true;
      this.snav.open();
      this._broadcaster.broadcast('OnResizeMenu', true);
      const state: any = { open: true, collapsed: true };
      this._LocalStorageService.setItem('lavuro-menu-state', state);
      return;
    }

    else if (!this.isMobileMenu() && (this.menuCollapsed || type == 'open')) {
      this.menuCollapsed = false;
      this.snav.open();
      this._broadcaster.broadcast('OnResizeMenu', true);
      const state: any = { open: true, collapsed: false };
      this._LocalStorageService.setItem('lavuro-menu-state', state);
      return;
    }

    // this.snav.open();
    this.snav.close();
    this._broadcaster.broadcast('OnResizeMenu', true);
    const state: any = { open: false, collapsed: false };
    this._LocalStorageService.setItem('lavuro-menu-state', state);
  }

  onSelect() {
    // this.sidenavChange('collapsed')
    this.stateChange()
  }

  stateChange(type?: string) {

    if (!this.snav.opened || type == 'open') {
      this.menuCollapsed = false;
      this.snav.open();
      this._broadcaster.broadcast('OnResizeMenu', true);
      const state: any = { open: true, collapsed: false };
      this._LocalStorageService.setItem('lavuro-menu-state', state);
      return;
    }

    else if (!this.isMobileMenu() && (!this.menuCollapsed || type == 'collapsed')) {
      this.menuCollapsed = !this.menuCollapsed;
      this.snav.open();
      this._broadcaster.broadcast('OnResizeMenu', true);
      const state: any = { open: true, collapsed: true };
      this._LocalStorageService.setItem('lavuro-menu-state', state);
      return;
    }

    else if (!this.isMobileMenu() && (this.menuCollapsed || type == 'open')) {
      this.menuCollapsed = false;
      this.snav.open();
      this._broadcaster.broadcast('OnResizeMenu', true);
      const state: any = { open: true, collapsed: false };
      this._LocalStorageService.setItem('lavuro-menu-state', state);
      return;
    }

    this.snav.close();
    this._broadcaster.broadcast('OnResizeMenu', true);
    const state: any = { open: false, collapsed: true };
    this._LocalStorageService.setItem('lavuro-menu-state', state);
  }

  onScroll() {
    this._broadcaster.broadcast('FinishScrollDown', true);
  }

  onLiteScroll() {
    this._broadcaster.broadcast('OnScroll', true);
  }

  showWhatsappLabel = true;
  openWhatsapp() {
    window.open(watsappURL({ text: 'Hola, tengo una duda sobre Manax', phone: '34613766415' }))
  }

  showChatPanel = false;
  showChat() {
    this.showChatPanel = !this.showChatPanel;
  }
}
